const containsPhrase = (text, phrase) => {
  const t = text.toLowerCase();
  const p = phrase.toLowerCase();

  return t.includes(p);
};

export { containsPhrase };
